import { Link } from "react-router-dom";

/**
 * Shared bottom-of-page footer with Privacy / Terms / Docs links.
 *
 * Required for the connector-directory submission — a reviewer landing
 * on any major surface (front page, authenticated dashboard, doc detail)
 * must be able to reach the privacy policy + terms in one click.
 * Without this, the legal pages exist as routes but aren't discoverable
 * from the SPA chrome — which a reviewer would (rightly) flag.
 *
 * Matches the visual language of the Landing-page footer at
 * [Landing.tsx — bottom of file](src/pages/Landing.tsx). When this lands,
 * replace the inline Landing footer with `<AppFooter />` to DRY them up;
 * left as inline there for now to keep the diff small.
 */
export function AppFooter() {
  return (
    <footer className="mt-auto border-t border-zinc-200 dark:border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-500">
        <span>Coauthor · built on the Skarp stack</span>
        <div className="flex items-center gap-4">
          <Link
            to="/getting-started"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Docs
          </Link>
          <Link
            to="/privacy"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Terms
          </Link>
          <a
            href="mailto:support@skarp.app"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Support
          </a>
          <a
            href="https://skarp.app"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            skarp.app
          </a>
        </div>
      </div>
    </footer>
  );
}
